import React from "react";
import {
    FormGroup,
    Button,
    ButtonToolbar,
    HelpBlock,
    Modal,
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Form, Field } from 'react-final-form';
import axios from 'axios';
import { host } from '../../../config';

class EditgridTableModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    componentWillMount() {
    }
    sendTypeEdit = () => {
        const { bidStatus } = this.props;
        this.setState({ typeEdit: true }, () => {
            this.onSubmit();
            this.sendMailHotel(bidStatus);
        });
    };

    closeTypeEdit = () => {
        this.onSubmit();
    };


    mailSentConfirm = () => {
        this.setState({
        editConfirmation: true
        })
    }

    onSubmit = () => {
        this.props.onSubmit()
        this.props.onClose()
    }

    sendMailHotel(bidStatus) {
        const tokenKey = JSON.parse(sessionStorage.getItem('auth')).token;
        const uploadUrl = `${host}/api/bidvalue/send_edit_message/`;
        return axios.post(uploadUrl, bidStatus, {
          headers: {
            Authorization: `Token ${tokenKey}`,
          },
        })
          .then(() => {
    
          })
          .catch((error) => {
            console.error('Error uploading document:', error);
          });
      }

      handleCellEdit = (row, fieldName, value) => {
        const { gridvalue, currentEventDate } = this.props;
        const updatedRows = gridvalue.map(item => {
            if (item.id === row.id) {
                return {
                    ...item,
                    [fieldName]: value
                };
            }
            return item;
        });
    
        const index = updatedRows.findIndex(item =>
            Object.keys(row).every(key => item[key] === row[key])
        );
    
        // Calculate numberOfNights if date_in and date_out are both present
        const { date_in, date_out,numberOfRooms } = updatedRows[index];
        if (fieldName === 'numberOfRooms' && value === '') {
            // If numberOfRooms is empty, remove the row from the array
            updatedRows.splice(index, 1);
        }
        
        if (fieldName === 'date_in' || fieldName === 'date_out') {
            const checkInDate = new Date(date_in);
            const checkOutDate = new Date(date_out);
    
            // Check if check-in date is later than check-out date
            if (checkInDate > checkOutDate) {
                alert('Check-out date cannot be less than Check-in date');
                updatedRows[index].date_out = null; // Reset date_out to null
                updatedRows[index].numberOfNights = null;
                // You may want to handle this differently based on your requirements
            } else {
                const diffInTime = checkOutDate.getTime() - checkInDate.getTime();
                const diffInDays = diffInTime / (1000 * 3600 * 24);
                updatedRows[index].numberOfNights = diffInDays.toString();
            }
        }
    
        // Check if check-in date is greater than or equal to tourData[0].start
        // const tourStartDate = new Date(currentEventDate);
        // if (date_in && new Date(date_in) < tourStartDate) {
        //     alert('Check-in date should be greater than or equal to the tour start date');
        //     updatedRows[index].date_in = null; // Reset date_in to null
        //     updatedRows[index].numberOfNights = null;
        //     // You may want to handle this differently based on your requirements
        // }
    
        // Update the parent component's gridvalue
        this.props.handleCellEdit(row, fieldName, value);
        // this.props.updateGridValue(updatedRows);
    };
    
    handleAddRow = () => {
        this.props.addRooms()
      };
      
      
    onHideCityNotesPopUP = () => {
        this.props.onClose();
    }
    render() {
        const selectRoomTypeOptions = ['Suite', 'King', 'Double', 'Two Beds', 'Junior Suite', '2 Bedroom Suite'];
        return (
            <div>
                <Modal show={this.props.show} onHide={this.onHideCityNotesPopUP}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Grid Table</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form
                            onSubmit={this.onSubmit}
                            render={({ handleSubmit, pristine, invalid }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div>
                                                <BootstrapTable
                                                    data={this.props.gridvalue}
                                                    striped
                                                    cellEdit={{
                                                        mode: 'click',
                                                        blurToSave: true,
                                                        afterSaveCell: this.handleCellEdit
                                                    }}
                                                >
                                                    <TableHeaderColumn hidden isKey dataField="id" width="100">
                                                        ID
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn dataField="roomType" width="150" headerAlign="center" dataAlign="center"
                                                        editable={{
                                                            type: 'select',
                                                            options: { values: selectRoomTypeOptions },
                                                            validator: (value) => value !== ''
                                                        }}
                                                    >
                                                        Room Type
                                                    </TableHeaderColumn>
                                                    <TableHeaderColumn dataField="numberOfRooms" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of rooms</TableHeaderColumn>
                                                    <TableHeaderColumn dataField="date_in" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date in &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                                                    <TableHeaderColumn dataField="date_out" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date out &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                                                    <TableHeaderColumn dataField="numberOfNights" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of nights</TableHeaderColumn>
                                                </BootstrapTable>
                                            </div>
                                            {/*<Button bsStyle="danger btn-sm" style={{ margin: "12px 12px", width: '10%', float: 'right' }} onClick={this.handleRemoveEmptyRows}>Remove</Button>*/}
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 left-padding-zero">
                                                <FormGroup style={{ marginBottom: '3px' }} >
                                                    <ButtonToolbar>
                                                        <div>
                                                            <Button bsStyle="success" style={{ margin: "12px 12px", width: '18%', float: 'right' }} onClick={this.handleAddRow}>Add Rooms</Button>
                                                            <Button bsStyle="success btn-sm" style={{ margin: "12px 12px", width: '10%', float: 'right',fontSize:'14px' }} onClick={this.mailSentConfirm} >Save</Button>
                                                        </div>
                                                    </ButtonToolbar>
                                                </FormGroup>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        />
                    </Modal.Body>
                    <Modal.Footer style={{ clear: 'both' }} />
                </Modal>
                {this.state.editConfirmation && (<Modal show={this.state.editConfirmation} onHide={this.closeTypeEdit} >
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Mail sent</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Do you want to notifiy hotel</p>
                        <ButtonToolbar>
                            <Button bsStyle="success btn-sm" onClick={this.sendTypeEdit}>
                                Yes
                            </Button>
                            <Button bsStyle="danger btn-sm" onClick={this.closeTypeEdit} >
                                No
                            </Button>
                        </ButtonToolbar>

                    </Modal.Body>
                </Modal>)}
            </div >

        )
    }
}

export default EditgridTableModal


// WEBPACK FOOTER //
// src/routes/tours/components/EditgridTableModal.js